import { Button } from 'tamagui'

export default () => <Button id="inverse" themeInverse />
